const JOB_CARD_ACTION = {
  JOB_READ_MORE: 'JOB_READ_MORE',
  JOB_CONSIDER_ME: 'JOB_CONSIDER_ME',
  JOB_BOOK_TI: 'JOB_BOOK_TI',
  JOB_START_TEST: 'JOB_START_TEST'
};

export default JOB_CARD_ACTION;
